import api from '../../../services/api/microfwk';
import { getProfileLastTouch } from '../../../utils/Socialization';
import qs from 'qs';

export const getAvatarCollectionsService = async () => {
  return await api.get('/services/user/profile/avatars/collection');
};

export const getProfilesService = async ({ user_token, gamification_id }) => {
  return await api.get('services/user/profile/read', {
    params: {
      lasttouch: getProfileLastTouch(),
      user_token,
      gamification_id,
    },
  });
};

export const createProfileService = async ({ params, body }) => {
  return await api.post(`services/user/profile/create`, body, {
    params,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
};

export const editProfileService = async ({ params, body }) => {
  return await api.post(`services/user/profile/update`, body, {
    params,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
};

export const deleteProfileService = async ({ params, body }) => {
  return await api.post(`services/user/profile/delete`, body, {
    params,
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
  });
};
